
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import AuthLayout from '@/components/auth/AuthLayout';
import FadeIn from '@/components/animations/FadeIn';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Access Needed"
      description="This area requires authentication"
    >
      <div className="space-y-6">
        <div className="text-center space-y-3">
          <FadeIn delay={0.1}>
            <div className="bg-blue-50 dark:bg-slate-700/40 p-4 rounded-lg mt-4">
              <p className="text-sm text-blue-700 dark:text-blue-300">
                <Icon name="Info" className="inline-block mr-2" size={16} />
                We'd love to show you this content, but you need to be signed in first.
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="space-y-3">
          <FadeIn delay={0.2}>
            <Button 
              onClick={() => navigate('/signin')}
              className="w-full bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-medium py-2.5"
            >
              Sign In
              <Icon name="LogIn" className="ml-2" size={16} />
            </Button>
          </FadeIn>
          
          <FadeIn delay={0.3}>
            <Button 
              variant="outline"
              onClick={() => navigate('/signup')}
              className="w-full border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200 font-medium py-2.5"
            >
              Create an Account
              <Icon name="UserPlus" className="ml-2" size={16} />
            </Button>
          </FadeIn>
        </div>
        
        <FadeIn delay={0.4}>
          <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-4">
            Need help? <Button variant="link" onClick={() => navigate('/support')} className="p-0 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300">Contact Support</Button>
          </p>
        </FadeIn>
      </div>
    </AuthLayout>
  );
};

export default Unauthorized;
